/**
 * user 相关存储信息
 *   authentication     登录用户的认证信息
 *   unReadNoticeCount  未读通知数量
 *   phases             阶段信息（菜单使用）
 *   progress           学习进度
 */

import axios from 'assets/js/myAxios'

const user = {
  state: {
    authentication: JSON.parse(localStorage.getItem('authentication')) || {},
    unReadNoticeCount: 0,
    phases: JSON.parse(sessionStorage.getItem('phases')) || [],
    progress: {}
  },
  mutations: {
    SET_AUTHENTICATION: (state, data) => {
      state.authentication = data
    },
    SET_UNREADNOTICECOUNT: (state, data) => {
      state.unReadNoticeCount = data
    },
    SET_PHASES: (state, data) => {
      state.phases = data
    },
    SET_PROGRESS: (state, data) => {
      state.progress = data
    }
  },
  actions: {
    // 注册
    register: ({ commit }, registerInfo) => {
      return new Promise((resolve, reject) => {
        axios.post('user/reg', registerInfo)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 登录
    login: ({ commit }, loginInfo) => {
      return new Promise((resolve, reject) => {
        axios.post('user/login', loginInfo)
          .then(response => {
            // 判断登录是否成功
            /**
             {
                "code": 0,
                "msg": "成功",
                "data": {
                    "nick": "&amp;lt;&lt;&gt;中文",
                    "token": "66drZe+ES/4FoE4lp1lYXSD7TiAXvLBrU3rL1UrZO8Y=",
                    "tokenExp": "2018-03-29T11:23:21.8685636+08:00",
                    "purExp": "2019-03-16T23:59:59"
                }
            }
             */
            if (response && response.token) {
              localStorage.setItem('authentication', JSON.stringify(response))
              commit('SET_AUTHENTICATION', response)
            }
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 失效用户登录信息
    invalidAuthentication: ({ commit, state }) => {
      if (state.authentication && state.authentication.token) {
        // 请求服务端退出登录
        axios.post('user/logout', {}, {
          headers: {
            Authorization: 'Bearer ' + state.authentication.token
          }
        })
        sessionStorage.setItem('phases', '[]')
        commit('SET_PHASES', [])
        localStorage.setItem('authentication', '{}')
        commit('SET_AUTHENTICATION', {})
      }
    },
    // 获取未读通知数量
    getUnReadNoticeCount: ({ commit }) => {
      axios.get('message/unreadcnt')
        .then(response => {
          commit('SET_UNREADNOTICECOUNT', response)
        })
    },
    // 阅读一条通知
    readOneNotice: ({ commit, state }) => {
      let count = state.unReadNoticeCount - 1
      if (count >= 0) {
        commit('SET_UNREADNOTICECOUNT', count)
      }
    },
    // 获取阶段数据
    getPhases: ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        axios.get('course/phases')
          .then(response => {
            sessionStorage.setItem('phases', JSON.stringify(response))
            commit('SET_PHASES', response)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 获取用户学习进度
    studyProgress: ({ commit, state }) => {
      if (state.authentication && state.authentication.token) {
        axios.get('course/progress')
          .then(response => {
            commit('SET_PROGRESS', response)
          })
      }
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js